import React, { useEffect } from "react";

const Section = ({ id, title, children }) => (
    <section id={id} className="scroll-mt-28 border-t border-[#e8e1d4] pt-10 mt-10 first:border-t-0 first:pt-0 first:mt-0">
        <h2 className="font-display font-semibold text-2xl sm:text-3xl tracking-tight">{title}</h2>
        <div className="mt-4 space-y-4 text-neutral-600 leading-relaxed text-[15px]">{children}</div>
    </section>
);

export default function Privacy() {
    useEffect(() => {
        document.title = "Privacy & Policies — MUVIARTS";
        if (window.location.hash) {
            const el = document.getElementById(window.location.hash.slice(1));
            if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 120);
        }
    }, []);

    return (
        <div data-testid="privacy-page">
            <section className="bg-cream py-16 lg:py-20 border-b border-[#e8e1d4]">
                <div className="mx-container">
                    <p className="overline mb-4">Legal</p>
                    <h1 className="font-display font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl">
                        Privacy &amp; <span className="italic text-brand-gold">Policies</span>
                    </h1>
                    <p className="mt-6 max-w-xl text-neutral-500 text-lg">How we handle your information, and our booking, refund and cancellation terms.</p>
                </div>
            </section>

            <div className="mx-container py-14 lg:py-20 max-w-3xl">
                <Section id="privacy-policy" title="Privacy Policy">
                    <p>MUVIARTS respects your privacy. We collect only the information you choose to share with us, such as your name, email address, phone number and project details, so we can respond to enquiries, process bookings and deliver our services.</p>
                    <p>We use this information solely to communicate with you, fulfil your bookings and improve our services. We do not sell your personal information. Payment transactions are processed securely by our payment partner (Razorpay); we do not store your card or banking details on our servers.</p>
                    <p>If you would like your details updated or removed from our records, please contact us and we will act on your request.</p>
                </Section>

                <Section id="refund-policy" title="Refund &amp; Cancellation Policy">
                    <p>All booking amounts and advance payments made to MuviArts are non refundable once the project has been booked or production has been initiated.</p>
                    <p>The booking amount is used to reserve project capacity and initiate the creative and production process. Therefore, cancellations after booking are not eligible for a refund.</p>
                    <p>If you have any concerns about the scope, requirements, pricing or process, we encourage you to clarify them with our team before making the booking or payment.</p>
                    <p>In exceptional circumstances, MuviArts may, at its sole discretion, offer an alternative solution, partial adjustment or service credit instead of a refund. Any such arrangement will be considered on a case by case basis and is not guaranteed.</p>
                    <p>If you are unsure about which package is suitable for your project, please contact our team before making the payment so we can clarify the scope and deliverables.</p>
                </Section>

                <Section id="contact" title="Questions?">
                    <p>For any questions about these policies, or before making a booking, reach us at <a href="mailto:support@muviarts.in" className="text-brand-golddark font-semibold hover:underline">support@muviarts.in</a> or call <a href="tel:+918065356108" className="text-brand-golddark font-semibold hover:underline">+91 8065356108</a>.</p>
                </Section>
            </div>
        </div>
    );
}
